/* eslint-disable key-spacing, wrap-iife */
(function($) {
  'use strict';
  $(window).on('load', function() {
    var $gtmEventTriggers = $('[data-gtm-event]');

    if (!window.dataLayer || !$gtmEventTriggers.length) {
      return;
    }

    $gtmEventTriggers.each(function() {
      var $trigger = $(this);

      $trigger.on($trigger.data('gtmOn') || 'click', function() {
        const event = $(this).attr('data-gtm-event');
        const value = $(this).attr('data-gtm-value');
        window.dataLayer.push({
          event: event,
          'custom.gtm.value': value || location.href,
        });
      });
    });
  });
})(jQuery);
